<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <span style="float: left">
        <a style="margin-left: 24px; margin-right: 24px;" v-on:click="$router.push({ name: 'server' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      </span>
      <MenuItem name="private_cloud_server_detail">
        基本信息
      </MenuItem>
      <!--<MenuItem name="2">-->
        <!--监控-->
      <!--</MenuItem>-->
      <MenuItem name="private_cloud_server_console">
        控制台
      </MenuItem>
      <MenuItem name="private_cloud_server_console_log">
        控制台日志
      </MenuItem>
      <MenuItem name="private_cloud_server_operate_log">
        操作日志
      </MenuItem>
    </Menu>
    <iframe :src="url" scrolling=auto frameborder=0 style="width: 100%; height: 700px; margin-top: 10px"></iframe>
  </div>
</template>

<script>
import { actionPrivateCloudServer } from '@/api/private-cloud/server'

export default {
  name: 'server-console',
  data () {
    return {
      url: ''
    }
  },
  created: function () {
    this.getVNCConsole()
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name, params: { id: this.$route.params.id }})
    },
    getVNCConsole () {
      let reqData = {
        'os-getVNCConsole': {
          type: 'novnc'
        }
      }
      actionPrivateCloudServer(reqData, this.$route.params.id).then(res => {
        this.url = res.data.console.url
        // window.open(res.data.console.url, '_blank')
      }).catch(res => {
        this.$Notice.error({
          title: '控制台当前不可用'
        })
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
